export default __webpack_public_path__ + "static/media/smoke.eb091621.mp4";